<script setup lang="ts">
import ErrorMessage from "@/components/form/ErrorMessage.vue"

interface Props {
  id: string
  label?: string
  feedback?: string
  hideLabel?: boolean
  colorClass?: string
  fontWeightClass?: string
  required?: boolean
}
withDefaults(defineProps<Props>(), {
  label: "",
  feedback: "",
  hideLabel: false,
  colorClass: "text-gray-700 dark:text-white",
  fontWeightClass: "font-medium",
  required: false
})
</script>

<template>
  <div>
    <label
      v-if="label && !hideLabel"
      :for="id"
      :class="[
        'mb-1 text-sm flex',
        colorClass,
        fontWeightClass,
        required && 'flex items-center gap-[9px]'
      ]"
    >
      <span>
        {{ label }}
      </span>
      <span v-if="required" class="text-xs text-primary first-letter:uppercase">
        {{ $t("validators.mixed.obligatory") }}
      </span>
    </label>

    <slot />

    <ErrorMessage
      v-if="feedback"
      :input-id="id"
      :label="label"
      :message="$t(feedback)"
    />
  </div>
</template>
